import React from "react";
import { createBrowserHistory } from "history";
import { Provider } from "react-redux";
import { applyMiddleware, createStore } from "redux";
import { routerMiddleware, ConnectedRouter } from "connected-react-router";
import createSagaMiddleware from "redux-saga";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import createRootReducer from "@store/rootReducer";
import AuthProvider from "./Auth/AuthProvider";
import Header from "./Components/Header/Header";
import Routes from "./routes/Routes";
import "./App.scss";
import rootSaga from "@store/rootSaga";

export const history = createBrowserHistory();

const sagaMiddleware = createSagaMiddleware();
export const store = createStore(
  createRootReducer(history),
  composeWithDevTools(
    applyMiddleware(routerMiddleware(history), sagaMiddleware)
  )
);

sagaMiddleware.run(rootSaga);

export const App = () => {
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <AuthProvider>
          <Header />
          <div className="main-wrapper">
            <Routes />
          </div>
        </AuthProvider>
      </ConnectedRouter>
    </Provider>
  );
};
